export const QUEUE_CACHE_RESOURCE = 'QUEUE_CACHE_RESOURCE';
export const queueCacheResource = (fetch$, fetchParameters) => ({type: QUEUE_CACHE_RESOURCE, payload: {fetch$, ...fetchParameters}});

export const DO_CACHE_RESOURCE = 'DO_CACHE_RESOURCE';
export const doCacheResource = (resource, expires = 300) => ({type: DO_CACHE_RESOURCE, payload: {...resource, meta: {expires}}});



// WEBPACK FOOTER //
// ./src/actions/cache.js